var _linearGradient, _linearGradient2, _linearGradient3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 511 511",
    height: 512,
    viewBox: "0 0 511 511",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.5,
    x2: 255.5,
    y1: 7.5,
    y2: 503.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 8.3866e-7,
    stopColor: "#75d1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3fff3"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.5,
    x2: 255.5,
    y1: 7.5,
    y2: 503.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3.6422e-7,
    stopColor: "#a7acff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc8ff"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.5,
    x2: 255.5,
    y1: 0,
    y2: 511
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004ea6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca42b2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m187.5 413.5c0 49.706-40.294 90-90 90s-90-40.294-90-90 40.294-90 90-90 90 40.294 90 90zm226-406c-49.706 0-90 40.294-90 90s40.294 90 90 90 90-40.294 90-90-40.294-90-90-90z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.5 97.5c0 49.706-40.294 90-90 90s-90-40.294-90-90 40.294-90 90-90 90 40.294 90 90zm226 226c-49.706 0-90 40.294-90 90s40.294 90 90 90 90-40.294 90-90-40.294-90-90-90z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m413.5 511c-53.762 0-97.5-43.738-97.5-97.5s43.738-97.5 97.5-97.5 97.5 43.738 97.5 97.5-43.738 97.5-97.5 97.5zm0-180c-45.49 0-82.5 37.01-82.5 82.5s37.01 82.5 82.5 82.5 82.5-37.01 82.5-82.5-37.01-82.5-82.5-82.5zm-316 180c-53.762 0-97.5-43.738-97.5-97.5s43.738-97.5 97.5-97.5c51.238 0 93.372 39.729 97.214 90h78.679l-17.197-17.196 10.607-10.607 35.303 35.304-35.303 35.304-10.607-10.607 17.198-17.198h-78.679c-3.843 50.271-45.977 90-97.215 90zm0-180c-45.491 0-82.5 37.01-82.5 82.5s37.009 82.5 82.5 82.5 82.5-37.01 82.5-82.5-37.009-82.5-82.5-82.5zm368 120h-104v-15h12.5v-45h-12.5v-15h104v15h-11.679l-15.75 45h27.429zm-76.5-15h25.929l-15.75-45h-10.179zm26.071-45 11.429 32.654 11.429-32.654zm-267.571 60h-100v-15h12.5v-45h-12.5v-15h100v15h-12.5v45h12.5zm-42.5-15h15v-45h-15zm-30 0h15v-45h-15zm22.5-133.894-35.303-35.303 10.606-10.607 17.197 17.198v-24.894c0-15.164 12.336-27.5 27.5-27.5h276c6.893 0 12.5-5.607 12.5-12.5v-13.785c-50.271-3.843-90-45.977-90-97.215 0-53.762 43.738-97.5 97.5-97.5s97.5 43.738 97.5 97.5c0 51.238-39.729 93.372-90 97.215v13.785c0 15.164-12.336 27.5-27.5 27.5h-276c-6.893 0-12.5 5.607-12.5 12.5v24.894l17.197-17.197 10.606 10.607zm316-287.106c-45.49 0-82.5 37.01-82.5 82.5s37.01 82.5 82.5 82.5 82.5-37.01 82.5-82.5-37.01-82.5-82.5-82.5zm-316 180c-53.762 0-97.5-43.738-97.5-97.5s43.738-97.5 97.5-97.5c51.238 0 93.372 39.729 97.214 90h78.679l-17.197-17.196 10.607-10.607 35.303 35.303-35.303 35.304-10.607-10.607 17.198-17.197h-78.679c-3.843 50.271-45.977 90-97.215 90zm0-180c-45.491 0-82.5 37.01-82.5 82.5s37.009 82.5 82.5 82.5 82.5-37.01 82.5-82.5-37.009-82.5-82.5-82.5zm351 120h-70v-15h12.5v-45h-12.5v-15h70v15h-12.5v45h12.5zm-42.5-15h15v-45h-15zm-285.5 15h-46v-15h15.5v-45h-15.5v-15h46v15h-15.5v45h15.5z",
    fill: "url(#SVGID_3_)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage);
export default __webpack_public_path__ + "static/media/stage.aaad0c5b.svg";
export { ForwardRef as ReactComponent };